import { css } from '@emotion/react'
import { useState, useEffect, useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import _ from 'lodash'
import { Container } from './styles'
import { withRouterProps } from '../../utils'
import Intro from './Intro'
import IncomeGoal from './IncomeGoal'
import EmployerPlanAccount from './EmployerPlanAccount'
import HomeActions from './HomeActions'

import { Drawer, Loading } from '../../components'
import UnderstandingYourResults from '../spend-down/understanding-your-results/UnderstandingYourResults'

function Home(props) {
  const [mode, setMode] = useState('idle')
  const {
    navigate,
    main: { sidebarActive, toggleSidebar, expandSidebar },
    store: {
      getBaseAdvicesForSpending,
      allSpendingRecommendedCases,
      getRecommendedAdvicesForSpending,
      spendingRecommendedCases,
      getBaseCase,
      recommendedCase,
      getRecommendedCase,
      getSurvivorPension,
      accountInsight: { sortedContributionList },
      getAccountInsight,
      config: { spendingMode, spendDownModeling, disableSpendDownModeling, isRetail, isSpendown },
      features: { enableSpendDown },
      config,
      auth: { hasStripeSessionId, retailLinkAccount, deleteStripeSessionId },
    },
  } = props
  const [status, setStatus] = useState('loading')
  const [drawer, setDrawer] = useState('')

  const handleCancel = useCallback(() => setDrawer(''), [setDrawer])

  useEffect(() => {
    if (spendDownModeling) {
      disableSpendDownModeling()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!config.onBoarded) {
      navigate('/welcome', { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.onBoarded])

  useEffect(() => {
    const handleRetailLinkAccount = async () => {
      if (hasStripeSessionId) {
        try {
          await retailLinkAccount()
          deleteStripeSessionId()
        } catch (e) {
          console.log(e)
        }
      }
    }
    handleRetailLinkAccount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getBaseCase()
        if (_.isEmpty(recommendedCase)) {
          await getRecommendedCase()
        }
        if (_.isEmpty(sortedContributionList)) {
          await getAccountInsight()
        }
        await getSurvivorPension()

        if (enableSpendDown) {
          if (spendingMode) {
            await getBaseAdvicesForSpending()
            if (_.isEmpty(spendingRecommendedCases)) {
              await getRecommendedAdvicesForSpending()
            }
            setMode('spending')
          } else {
            setMode('retWithinThreeYears')
          }
        } else {
          setMode('retMoreThanThreeYearsAway')
        }
        setStatus('success')
      } catch (err) {
        setStatus('error')
        console.error(err)
      }
    }

    fetchData()
  }, [
    enableSpendDown,
    getBaseAdvicesForSpending,
    getBaseCase,
    getRecommendedAdvicesForSpending,
    getRecommendedCase,
    getSurvivorPension,
    getAccountInsight,
    sortedContributionList,
    recommendedCase,
    spendingMode,
    spendingRecommendedCases,
  ])

  useEffect(() => {
    if (sidebarActive) {
      toggleSidebar()
    }
    return () => expandSidebar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (status === 'error') {
    return (
      <div
        css={css`
          color: #e31e27;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          padding: 0.25rem 0 0.75rem 0;
        `}>
        Something went wrong, please try again later.
      </div>
    )
  }

  const displayEmployerPlanAccount = isRetail ? (!isSpendown ? false : true) : true

  return status === 'success' ? (
    <Container>
      <Intro mode={mode} />
      <IncomeGoal mode={mode} />
      {displayEmployerPlanAccount && (
        <EmployerPlanAccount
          allSpendingRecommendedCases={allSpendingRecommendedCases}
          mode={mode}
          setDrawer={setDrawer}
        />
      )}
      <HomeActions mode={mode} />
      <Drawer active={drawer === 'Personalized Help'} width='100%'>
        <UnderstandingYourResults
          setDrawer={setDrawer}
          handleCancel={handleCancel}
          openedFromHome
        />
      </Drawer>
    </Container>
  ) : (
    <Loading />
  )
}

export default withRouterProps(inject('store', 'main')(observer(Home)))
